





























import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class Widget extends Mixins<BaseComponent>(BaseComponent) {

  @Prop()
  public title!: string;

  @Prop({default: ''})
  public subtitle!: string;

  @Prop({default: 1})
  public height!: number;

  @Prop({default: 1})
  public width!: number;

  @Prop({default: false})
  public widgetLoading!: boolean;

  @Prop({default: null})
  public linkRoute!: string;

  @Prop({default: 'paragraph'})
  public loaderType!: string;

  get headerHeight(): number {
    return 80;
  }

  get contentHeight(): number {
    return this.height * 100;
  }

  get totalHeight(): number {
    return this.headerHeight + this.contentHeight;
  }
}
